import generatedNewsIndex from './geoNews.index.generated.json';
import { applyGeoNewsVisualAssets } from './geoVisualAssets';

export type GeoNewsCategorySlug = 'reports' | 'insights' | 'intelligence';

export interface GeoNewsCategory {
  slug: GeoNewsCategorySlug;
  sourcePath: string;
  title: string;
  description: string;
}

export interface GeoNewsIndexArticle {
  id: string;
  slug: string;
  category: GeoNewsCategorySlug;
  categoryTitle: string;
  title: string;
  summary: string;
  cover: string;
  date: string;
  author: string;
}

const payload = generatedNewsIndex as {
  migratedAt: string;
  source: string;
  categories: GeoNewsCategory[];
  articles: GeoNewsIndexArticle[];
};

export const geoNewsCategories = payload.categories;
export const geoNewsArticles = payload.articles.map(applyGeoNewsVisualAssets);
export const geoNewsMigratedAt = payload.migratedAt;

export const getGeoNewsCategory = (slug?: string) =>
  geoNewsCategories.find((category) => category.slug === slug);

export const getGeoNewsArticlesByCategory = (slug: string) =>
  geoNewsArticles.filter((article) => article.category === slug);

export const getGeoNewsArticleById = (id: string) =>
  geoNewsArticles.find((article) => article.id === id);

export const getGeoNewsArticlePath = (
  article: Pick<GeoNewsIndexArticle, 'category' | 'id'>,
) => `/knowledge/${article.category}/${article.id}`;
